import {
  Autocomplete,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import { Controller } from 'react-hook-form'
import { useAreaFormContext } from './AreaFormContext'

export const AreaName: FC = () => {
  const { control, areaNameHistories } = useAreaFormContext()

  return (
    <Controller
      name="name"
      control={control}
      rules={{
        required: '1文字以上入力してください',
        maxLength: { value: 50, message: '50文字以内で入力してください' },
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} sx={{ gap: 0.5 }} required>
          <Typography
            component="label"
            sx={{
              color: 'text.primary',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            検査箇所名
          </Typography>
          <Autocomplete
            freeSolo
            fullWidth
            options={areaNameHistories}
            value={field.value}
            onChange={(_, newValue) => {
              field.onChange(newValue ?? '')
            }}
            onInputChange={(_, newValue) => {
              field.onChange(newValue ?? '')
            }}
            renderInput={params => (
              <TextField
                {...params}
                required
                sx={{ backgroundColor: 'white' }}
              />
            )}
          />
          {error ? (
            <FormHelperText sx={{ margin: 0 }}>{error.message}</FormHelperText>
          ) : (
            <Typography variant="caption" color="text.secondary">
              過去に使用された検査箇所名から選択するか、新規に入力してください。
            </Typography>
          )}
        </FormControl>
      )}
    />
  )
}
